import { render, staticRenderFns } from "./Reserva.vue?vue&type=template&id=3954a884&scoped=true"
import script from "./Reserva.vue?vue&type=script&lang=js"
export * from "./Reserva.vue?vue&type=script&lang=js"
import style0 from "./Reserva.vue?vue&type=style&index=0&id=3954a884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954a884",
  null
  
)

export default component.exports